<div class="app-page">
  <mat-toolbar>
    <a mat-icon-button [routerLink]="['/search']" aria-label="Back to search menu">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </a>
    <span>Players by tag</span>
  </mat-toolbar>

  @if (isLoading) {
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  }

  @if (!isLoading && !loadError && tagGroups.length === 0) {
    <div class="empty-state">
      <mat-icon>info</mat-icon>
      <span>No tagged players found</span>
    </div>
  }

  @if (!isLoading && loadError) {
    <div class="empty-state">
      <mat-icon>error_outline</mat-icon>
      <span>Could not load tagged players</span>
    </div>
  }

  @if (tagGroups.length > 0) {
    <mat-accordion class="tag-accordion" multi>
      @for (group of tagGroups; track group.tagId) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="tag-chip" [class]="group.tagColor">{{ group.tagText }}</span>
              <span class="tag-count">({{ group.players.length }})</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="players-list">
            @for (player of group.players; track getPlayerId(player)) {
              <a class="player-row" [routerLink]="['/player/details', getPlayerId(player)]">
                <div class="player-content">
                  <span class="player-name">{{ getLastName(player) }}, {{ getFirstName(player) }}</span>
                  <span class="player-meta">{{ getPositionId(player) | position }} | {{ getDateOfBirth(player) | date:'yyyy-MM-dd' }}</span>
                </div>
              </a>
            }

            @if (group.players.length === 0) {
              <div class="empty-tag-group">No players for this tag</div>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
